import { DisableReason } from "../models";
export class UserAccountInfo {
    userId: string;
    accountStatusCode: string;
    globalRoleCode: string;
    disableReasonCode: string;
    disableReason: DisableReason;
    disableReasonComment: string;
}


// WEBPACK FOOTER //
// ./src/app/models/userAccountInfo.ts